export const queryKeys = {
  GET_AGREEMENTS_LIST: 'getAgreementsList',
  GET_AGREEMENT_DETAILS: 'getAgreementDetails',
  GET_AGREEMENT_STATS: 'getAgreementStats',
  GET_AGREEMENTS: 'getAgreements',
  GET_CONTRACT_TEMPLATE: 'getContractTemplate',
  GET_CONTRACT_TEMPLATES: 'getContractTemplates',
  GET_DRAFT_AGREEMENT: 'getDraftAgreement',
  TEAM_BUDGETS: 'getTeamBudgets',
  TEAM_BUDGET_DETAILS: 'getTeamBudget',
  ORG_BUDGETS: 'getOrgBudgetsList',
  ORG_BUDGETS_SUMMARY: 'getBudgetsOverview',
  USER_PERMISSIONS: 'getUserPermissions',
  USER_PERMISSIONS_LIST: 'getUserPermissionsList',
  ELIGIBLE_ATHLETES: 'getEligibleAthletes',
  GET_AGREEMENT_ATHLETES: 'getAgreementAthletes',
  TEAM_POSITIONS: 'getTeamPositions',
  ME: 'getMe',
  ALL_TEAMS: 'getAllTeams',
  TEAM_ATHLETE_PROFILE: 'getTeamAthleteProfile',
  TAGS: 'getTags',
  AGREEMENT_PAYMENTS: 'getAgreementPayments',
  TEAM_PAYMENTS: 'getTeamPayments',
  PAYMENT_REQUEST: 'getPaymentRequest',
  TEAM_ATHLETES_LIST: 'getTeamAthletesList',
  ATHLETE_DOCUMENTS: 'getAthleteDocuments',
  RECRUITS: 'getRecruitList',
  ATHLETE_EARNINGS: 'getAthleteEarnings',
  CR_ATHLETE_PROFILE: 'getCRAthleteProfile',
  ATHLETE_AGREEMENTS: 'getAthleteAgreements',
  ATHLETE_NOTES: 'getAthleteNotes',
  LINKABLE_PROFILES: 'getLinkableProfiles',
  NIL_CATEGORIES: 'getNilCategories',
  THIRD_PARTY_NIL_INFLCR: 'getThirdPartyNilInfluencer',
  /** Scholarship Packages */
  SCHOLARSHIP_PACKAGES: 'getScholarshipPackages',
  AWARD_CATEGORIES: 'getAwardCategories',
  TEAM_PAYMENTS_STATS: 'getTeamPaymentsStats',
  ANNUAL_PAYMENTS: 'getAnnualPayments',
  TEAM_BUDGET_COLUMN_PREFERENCES: 'teamBudgetColumnPreferences',
  TEAM_BUDGET_GROUP_COLUMN_PREFERENCES: 'getTeamBudgetGroupColumnPreferences',
  BUDGET_GROUP: 'getBudgetGroup',
  BUDGET_GROUP_TIMELINE: 'getBudgetGroupTimeline',
  PAYMENT_HISTORY: 'getTeamPaymentHistory',
  BUDGET_GROUPS_COMPACT: 'getBudgetGroupsCompact',
  GET_AGREEMENTS_BY_CONTRACT: 'getAgreementsByContract',
  NOTIFICATION_SETTINGS: 'getNotificationSettings',
  GET_ACADEMIC_YEARS: 'getAcademicYears',
  PLAYER_PERSONNEL_PLAYER_SEARCH: 'searchPlayerPersonnelPlayers',
  PLAYER_PERSONNEL_PLAYER_STATS: 'getPlayerPersonnelPlayerStats',
  PLAYER_PERSONNEL_PLAYER_SEASONS: 'getPlayerPersonnelSeasons',
  AGENTS: 'getAgents',
  AGENTS_BY_ATHLETE: 'getAgentsByAthletes',
  GET_ATHLETE_CONTRACT: 'getAthleteContract',
} as const;

export const teamworksRedirectPaths = {
  TUM: '/profiles',
} as const;
